<template>
  <v-container class="d-flex align-start">
    <card-custom
      class="d-inline"
      event_name="sysacq"
      :dropdown_state="true"
      :teaser_content="false"
      style="height: 100%;"
    >
      <template v-slot:prepend_icon>
        <icon icon="mdi:router-network-wireless" height="24px" color="grey" />
      </template>
      <template v-slot:title>
        <div class="text-subtitle-2">Système d'acquisition / Transfert de données</div>
      </template>
      <template v-slot:teaser>
        <Icon icon="mdi:numeric-3-box" color="grey"/>
        <score-bloc
          event_name="dispo_score"
          text_align="left"
          indicator_color="black"
          indicator_text="97.5 %"
          desc_color="grey"
          desc_text="Disponibility"
          icon_type="up"
        />

        <score-bloc
          event_name="perf_score"
          text_align="right"
          indicator_color="black"
          indicator_text="68.7 %"
          desc_color="grey"
          desc_text="Performance Score"
          icon_type="middle"
        />

        <score-bloc
          event_name="ip_score"
          text_align="left"
          indicator_color="black"
          indicator_text="75.3 %"
          desc_color="grey"
          desc_text="IP"
          icon_type="down"
        />

      </template>
      <template v-slot:content>
        my content
      </template>
    </card-custom>
  </v-container>
</template>

<script>
    import CardCustom from "../components/UI_kit/CardCustom.vue"
    import ScoreBloc from "../components/UI_kit/ScoreBloc.vue"
    import { Icon } from '@iconify/vue2'

    export default {
      components: {
        CardCustom,
        ScoreBloc,
        Icon,
      },
      name: "Test",

      data() {
        return {
          sysacq_table: [
            {
              icon: 'mdi-numeric-2-box',
              icon_color: 'orange',
              category: 'Sonde température module',
              message: 'Message 1, Message 2, Message 3',
            },
            {
              icon: 'mdi-numeric-1-box',
              icon_color: 'blue',
              category: 'Communication site',
              message: 'Message 1',
            },
          ]
        }
      }
    }

</script>

<style scoped>

</style>
